import {ActivityWithProcessDto, CreatedByProcessDto, UserDto} from '../services/generated';
import {Activity} from './Activity';
import {ProcessUsedInLibraries} from './ProcessUsedInLibraries';

export class ActivityWithProcess extends Activity implements ActivityWithProcessDto {
  public processes: ProcessUsedInLibraries[] | null;
  public createdByProcess: CreatedByProcessDto | null;
  public createdByProcessOwner: UserDto | null;

  constructor(link: ActivityWithProcessDto) {
    super(link);
    this.processes = link.processes?.map(process => new ProcessUsedInLibraries(process)) || null;
    this.createdByProcess = link.createdByProcess;
    this.createdByProcessOwner = link.createdByProcessOwner;
  }
}
